import { DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import React from 'react'
import { Perfil } from '../types'
import { Button, ControlledTextField } from 'src/components/forms'
import { z } from 'src/lib'
import { PerfilPostFields } from '../api/schemas'
import { HttpPerfilesABM } from '../api/httpPerfilesABM'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { EntityWithIdAndDescriptionFields } from 'src/types'

const schemaFormPostPerfil = z.object({
    [PerfilPostFields.Nombre]: z.string(),
})

type SchemaFormPostPerfil = z.infer<typeof schemaFormPostPerfil>

type DialogPerfilABMProps = {
    closeDialog: () => void
    perfil?: Perfil
}

export const DialogPerfilABM = ({ perfil, closeDialog }: DialogPerfilABMProps) => {

    const { control, handleSubmit } = useForm<SchemaFormPostPerfil>({
        resolver: zodResolver(schemaFormPostPerfil),
        values: {
            [PerfilPostFields.Nombre]: perfil?.[EntityWithIdAndDescriptionFields.Description] || ''
        }
    })

    const submitPerfil = (data: SchemaFormPostPerfil) => {
        return perfil
            ? HttpPerfilesABM.putPerfil(perfil.id, data)
            : HttpPerfilesABM.postPerfil(data)
    }

    const onSubmitWrapper = () => {
        return new Promise<void>((resolve, reject) => {
            handleSubmit(
                (formData) => {
                    submitPerfil(formData)
                        .then(() => {
                            setTimeout(closeDialog, 500);
                            resolve();
                        })
                        .catch(reject)
                },
                (validationErrors) => {
                    reject(validationErrors);
                }
            )();
        });
    };

    return (
        <>
            <DialogTitle>
                {perfil ? 'Editar perfil' : 'Nuevo perfil'}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={4} sx={{ pt: 2 }}>
                    <Grid item md={6}>
                        <ControlledTextField
                            name={PerfilPostFields.Nombre}
                            control={control}
                            label='Nombre'
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='text' color='primary' onClick={closeDialog}>
                    Cancelar
                </Button>
                <Button
                    variant='contained'
                    color='primary'
                    promise={onSubmitWrapper}
                >
                    Guardar
                </Button>
            </DialogActions>
        </>
    )
}
